import DriverListScreen from "../screens/drivers/list";
import UserListScreen from "../screens/users";
import PackageIncomeScreen from "../screens/packages/income";
import PackageRegisterScreen from "../screens/packages/register";
import PackageListScreen from "../screens/packages/list";
import DriverIncomeScreen from "../screens/drivers/income";

export const sidebardata = [
  {
    title: "Дайвар",
  },
  {
    slug: "register",
    title: "Бүртгэх",
    icon: "uil-envelope-add",
    component: <PackageRegisterScreen />,
  },
  {
    slug: "list",
    title: "Дайврууд",
    icon: "ri-file-list-line",
    component: <PackageListScreen />,
  },
  {
    slug: "revenue",
    title: "Орлого, зарлага",
    icon: "ri-exchange-dollar-line",
    component: <PackageIncomeScreen />,
  },
  {
    title: "Жолооч",
  },
  {
    slug: "drivers",
    title: "Жолооч",
    icon: "ri-car-line",
    component: <DriverListScreen />,
  },
  {
    slug: "bill",
    title: "Тооцоо",
    icon: "ri-calculator-line",
    component: <DriverIncomeScreen />,
  },
  {
    title: "Хэрэглэгч",
  },
  {
    slug: "users",
    title: "Хэрэглэгч",
    icon: "uil-user",
    component: <UserListScreen />,
  },
];
